var map = {
	"../pages/account/account.module": [
		549,
		12
	],
	"../pages/address/address.module": [
		551,
		11
	],
	"../pages/basket/basket.module": [
		553,
		10
	],
	"../pages/category/category.module": [
		554,
		9
	],
	"../pages/contact/contact.module": [
		542,
		8
	],
	"../pages/detail/detail.module": [
		546,
		7
	],
	"../pages/forgotpswd/forgotpswd.module": [
		544,
		6
	],
	"../pages/login/login.module": [
		545,
		5
	],
	"../pages/my-order/my-order.module": [
		547,
		4
	],
	"../pages/my-orders/my-orders.module": [
		548,
		3
	],
	"../pages/order/order.module": [
		552,
		2
	],
	"../pages/register/register.module": [
		543,
		1
	],
	"../pages/search/search.module": [
		550,
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 267;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src lazy
// module id = 267
// module chunks = 13